/**
 * Our Works Data Configuration
 * Centralized data for all portfolio works organized by categories
 */

import SdsLOGO from "../assets/images/our-works-logos/sds-logo.svg";
import MahiveLOGO from "../assets/images/our-works-logos/mahive-logo.png";
import DTLogo from '../assets/images/our-works-logos/DT-logo.png';
import emarah_logo from '../assets/images/our-works-logos/emarah_logo.jpeg';
import adgroadglo_LOGO from '../assets/images/our-works-logos/adgroadglo_LOGO.png';
import FILLR_Logo from '../assets/images/our-works-logos/filler.png';
import bushra_logo from '../assets/images/our-works-logos/bushra_logo.png';
import HameediaHaj from '../assets/images/our-works-logos/HameediaHaj.png';
import kawatihi_logo from '../assets/images/our-works-logos/kawatihi_logo.png';
import mahira_logo from '../assets/images/our-works-logos/mahira_logo.png';
import franchise_thalaiva from '../assets/images/our-works-logos/franchise_thalaiva.jpg';
import Hameedia_realty from '../assets/images/our-works-logos/Hameedia-realty.png';

import galleryOne from '../assets/images/gallery/gallery-1.jpg';
import galleryTwo from '../assets/images/gallery/gallery-2.jpg';
import galleryThree from '../assets/images/gallery/gallery-3.jpg';

const ourWorksData = [
    {
        id: 1,
        category: "Architecture & Interior Designing",
        categoryTitle: "Architecture <br /> & Interior Designing",
        floatingIcons: {
            left: "gallaxy",
            right: "saturn",
            position: "bottom"
        },
        works: [
            {
                id: 1,
                title: "SDS",
                description: "Sathish Design Studio is a Chennai-based engineering consultancy delivering precise, practical, and dependable design solutions.",
                logo: SdsLOGO,
                hasModal: true,
                modalContent: {
                    description: "Sathish Design Studio is a Chennai-based engineering consultancy delivering precise, practical, and dependable design solutions.",
                    photos: [
                        galleryOne,
                        galleryTwo,
                        galleryThree,
                        galleryOne,
                        galleryTwo,
                        galleryThree
                    ],
                    instagramPosts: [
                        // Instagram Official Embed - BEST PRACTICE ✅
                        // Supports: Reels, Videos, Images, Carousels
                        // Requirements: Post must be PUBLIC
                        // Format: https://www.instagram.com/p/{POST_ID}/ or https://www.instagram.com/reel/{REEL_ID}/
                        // Example: "https://www.instagram.com/p/ABC123xyz/"
                        // Example: "https://www.instagram.com/reel/XYZ789abc/"
                        // Note: Uses Instagram's official embed (100% allowed, no downloading/reuploading)
                    ],
                    instagramProfile: "https://www.instagram.com/sathiesh_design_studio"
                }
            },
            {
                id: 2,
                title: "Design Triangle",
                description: "Design Triangle is a Chennai-based interior design studio creating functional, elegant spaces tailored to modern lifestyles.",
                logo: DTLogo,
                hasModal: true,
                modalContent: {
                    description: "Design Triangle is a Chennai-based interior design studio creating functional, elegant spaces tailored to modern lifestyles.",
                    photos: [
                        galleryOne,
                        galleryTwo,
                        galleryThree
                    ],
                    instagramPosts: [],
                    instagramProfile: "https://www.instagram.com/designtriangle07"
                }
            },
            {
                id: 3,
                title: "Mahive Engineering Solutions",
                description: "Mahive Engineering Solutions, based in Maryland, USA, provides practical engineering and design support to help turn ideas into clear, workable plans.",
                logo: MahiveLOGO,
                hasModal: true,
                modalContent: {
                    description: "Mahive Engineering Solutions, based in Maryland, USA, provides practical engineering and design support to help turn ideas into clear, workable plans.",
                    photos: [
                        galleryOne,
                        galleryTwo,
                        galleryThree
                    ],
                    instagramPosts: [],
                    instagramProfile: "https://www.instagram.com/mahive_llc"
                }
            }
        ]
    },
    {
        id: 2,
        category: "Builders & Real Estate",
        categoryTitle: "Builders  <br /> & Real Estate",
        floatingIcons: {
            right: "rover",
            position: "bottom"
        },
        works: [
            {
                id: 1,
                title: "Emarah Properties",
                description: "A real estate brand offering thoughtfully developed residential and investment properties.",
                logo: emarah_logo,
                hasModal: true,
                modalContent: {
                    description: "A real estate brand offering thoughtfully developed residential and investment properties.",
                    photos: [
                        galleryOne,
                        galleryTwo,
                        galleryThree
                    ],
                    instagramPosts: [],
                    instagramProfile: null
                }
            },
            {
                id: 2,
                title: "Hameedia Realty",
                description: "A real estate brand connecting people globally to invest in luxurious Dubai properties with high ROI",
                logo: Hameedia_realty,
                hasModal: true,
                modalContent: {
                    description: "A real estate brand connecting people globally to invest in luxurious Dubai properties with high ROI",
                    photos: [
                        galleryOne,
                        galleryTwo,
                        galleryThree
                    ],
                    instagramPosts: [],
                    instagramProfile: "https://www.instagram.com/hameediarealty"
                }
            }
        ]
    },
    {
        id: 3,
        category: "Cosmetology & HealthCare",
        categoryTitle: "Cosmetology  <br /> & HealthCare",
        floatingIcons: {
            left: "moon",
            right: "rocketIcon",
            position: "bottom"
        },
        works: [
            {
                id: 1,
                title: "AdGro & AdGlo Clinics",
                description: "Aesthetic and wellness clinics providing advanced treatments focused on skin, hair, and overall appearance.",
                logo: adgroadglo_LOGO,
                hasModal: true,
                modalContent: {
                    description: "Aesthetic and wellness clinics providing advanced treatments focused on skin, hair, and overall appearance.",
                    photos: [
                        galleryOne,
                        galleryTwo,
                        galleryThree
                    ],
                    instagramPosts: [],
                    instagramProfile: "https://www.instagram.com/adgrohairandgloskinerode"
                }
            },
            {
                id: 2,
                title: "Fillr By Dr. F",
                description: "A premium aesthetic skin clinic in Adyar, Chennai, delivering treatments for natural, refined results.",
                logo: FILLR_Logo,
                hasModal: true,
                modalContent: {
                    description: "A premium aesthetic skin clinic in Adyar, Chennai, delivering treatments for natural, refined results.",
                    photos: [
                        galleryOne,
                        galleryTwo,
                        galleryThree
                    ],
                    instagramPosts: [],
                    instagramProfile: "https://www.instagram.com/fillrbydr.f"
                }
            }
        ]
    },
    {
        id: 4,
        category: "Travel & Tourism",
        categoryTitle: "Travel <br /> & Tourism",
        floatingIcons: {
            right: "dna",
            position: "bottom"
        },
        works: [
            {
                id: 1,
                title: "Bushra Haj Services",
                description: "A leading Haj Group Organiser in India, ensuring a smooth, guided pilgrimage experience.",
                logo: bushra_logo,
                hasModal: true,
                modalContent: {
                    description: "A leading Haj Group Organiser in India, ensuring a smooth, guided pilgrimage experience.",
                    photos: [
                        galleryOne,
                        galleryTwo,
                        galleryThree
                    ],
                    instagramPosts: [],
                    instagramProfile: "https://www.instagram.com/bushra_haj_service"
                }
            },
            {
                id: 2,
                title: "Hameedia Haj Service",
                description: "A pilgrimage service organization offering end-to-end support for Hajj and Umrah travelers.",
                logo: HameediaHaj,
                hasModal: true,
                modalContent: {
                    description: "A pilgrimage service organization offering end-to-end support for Hajj and Umrah travelers.",
                    photos: [
                        galleryOne,
                        galleryTwo,
                        galleryThree
                    ],
                    instagramPosts: [],
                    instagramProfile: "https://www.instagram.com/hameediahajservice"
                }
            }
        ]
    },
    {
        id: 5,
        category: "E-commerce & Other",
        categoryTitle: "E-commerce <br /> & Other",
        floatingIcons: {
            left: "atoms",
            right: "atom",
            position: "bottom",
            leftClass: "rotate",
            rightClass: "rotate"
        },
        works: [
            {
                id: 1,
                title: "Kawatihi Fish Company",
                description: "A Qatar based seafood brand supplying fresh, high-quality fish with a focus on hygiene and reliability.",
                logo: kawatihi_logo,
                hasModal: true,
                modalContent: {
                    description: "A Qatar based seafood brand supplying fresh, high-quality fish with a focus on hygiene and reliability.",
                    photos: [
                        galleryOne,
                        galleryTwo,
                        galleryThree
                    ],
                    instagramPosts: [],
                    instagramProfile: "https://www.instagram.com/kawatihi_kw"
                }
            },
            {
                id: 2,
                title: "Henna by Mahira Mohsin",
                description: "Leading henna brand known for intricate, elegant, and customized designs.",
                logo: mahira_logo,
                hasModal: false
            },
            {
                id: 3,
                title: "Franchise Thalaiva",
                description: "A business consultancy helping brands expand through structured and strategic franchise models.",
                logo: franchise_thalaiva,
                hasModal: false
            }
        ]
    }
];

export default ourWorksData;

